import { ITelemetryItem } from '@microsoft/applicationinsights-web';
import { isEqual, truncate } from 'lodash-es';

const appInsightsMaxPropLength = 8192;

export function createSafeProp<T extends {}>(value: string | T) {
  const t = (val: string) =>
    truncate(val, { omission: '... [truncated]', length: appInsightsMaxPropLength });
  if (typeof value === 'string') {
    return t(value);
  }
  try {
    if (isEqual(value, {})) {
      return null;
    }
    const json = JSON.stringify(value);
    return t(json);
  } catch (err: any) {
    return `Error serializing/truncating json property: ${err.message}`;
  }
}

export function createSafeProps<T extends {}>(val: T): { [name: string]: string } {
  const result: { [name: string]: string } = {};
  Object.entries(val).forEach(([key, value]) => {
    const propVal = createSafeProp(value as string);
    if (propVal != null) {
      result[String(key)] = propVal;
    }
  });
  return result;
}

export function patchTelemetryProps<T extends {}>(item: ITelemetryItem, props: T) {
  if (item?.data != null) {
    const oldProps = item.data;
    const newProps = createSafeProps(props);
    item.data =
      oldProps != null
        ? {
            ...oldProps,
            ...newProps,
          }
        : newProps;
    return true;
  }
  return false;
}
